import SimpleSignService from './SimpleSignService';

export default SimpleSignService;
